import Cookies from "cookies-js";

/**
 * Retrieves the external cookie with the specified name.
 *
 * @param {string} name - the name of the cookie to retrieve
 * @return {unknown} the value of the external cookie, or undefined if not found
 */
const getExternalCookie = <T>(key: string): T | undefined => {
    const cookieContent = Cookies.get(key);
    return cookieContent ? (JSON.parse(cookieContent) as T) : undefined;
};

/**
 * Returns the reservationId from the 'reserveToBuy' cookie when available
 * We don't set this cookie, so we have to retrieve it in this way.
 */
export function getReservationIdFromCookies(): string {
    const cookie = getExternalCookie<{ reservationId: string }>("reserveToBuy");
    return cookie ? cookie.reservationId : "";
}
